export const AccountLoginBadCredentials = "app:account:login:bad-credentials";
export const AccountLoginUnconfirmed = "app:account:login:unconfirmed";
export const AccountLoginDisabled = "app:account:login:disabled";

export const ProjectManagerWithoutProjectError = "project-manager-without-project";
export const MarketManagerWithoutMarketError = "market-manager-without-market";
export const OrganizationManagerWithoutOrganizationError = "organization-manager-without-organization";
